import {Modal} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React, {memo} from 'react'

import {Header} from './components/Header'
import * as classes from './Drawer.classes'

type DrawerProps = {
  children?: React.ReactNode
  close: VoidFunction
  fullScreen?: boolean
  opened: boolean
  title?: string
}

export const Drawer = memo(
  ({children, close, fullScreen, opened, title}: DrawerProps): React.ReactElement => (
    <Modal.SidePanel
      anchor="bottom"
      className={clsx(classes.mobileDrawer, fullScreen && classes.fullScreen)}
      opened={opened}
    >
      <Modal.Body className={classes.mobileDrawerBody} p={void 0}>
        {title && <Header onClose={close} title={title} />}
        {children}
      </Modal.Body>
    </Modal.SidePanel>
  ),
)
